<template>
  <div class="c-product-card">
      123456789
  </div>
</template>
